<template>
  <div class="question" :class="`type-${number + 1}`">
    <div class="question-wrap">
      <anime-sort-select-question-title :isVisible="data.title_view" :number="number" />
      <div class="question-a" :class="{'is-visible': data.choices_view}">
        <button
          v-for="(choice, index) in data.choices"
          :key="choice.id"
          class="question-a-answer"
          :class="{'is-selected': !data.multi_type ? choice.id === selectedType : choice.selected}"
          @click="!data.multi_type ? $emit('clickedAnswer', data.type, choice.id, index) : $emit('clickedMultiAnswer', choice.id, index)"
          v-html="choice.text"
        />
        <button v-if="data.multi_type" class="question-a-answer no-visible" />
      </div>
      <template v-if="data.multi_type">
        <button class="question-decide" :class="{'is-visible': data.choices_view}" @click="$emit('clickedNext')">
          <img class="question-decide-chara question-decide-chara--n" src="@/assets/images/next_n.svg" alt="N" />
          <img class="question-decide-chara question-decide-chara--e" src="@/assets/images/next_e.svg" alt="E" />
          <img class="question-decide-chara question-decide-chara--x" src="@/assets/images/next_x.svg" alt="X" />
          <img class="question-decide-chara question-decide-chara--t" src="@/assets/images/next_t.svg" alt="T" />
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import AnimeSortSelectQuestionTitle from './AnimeSortSelectQuestionTitle.vue'
export default {
  components: { AnimeSortSelectQuestionTitle },
  name: 'SortSelectQuestion',
  props: {
    number: {
      type: Number,
      default: 0
    },
    data: {
      type: Object
    },
    selectedType: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.question {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  &-wrap {
    width: 310/375 * 100%;
    @include media() {
      width: 640px;
    }
  }
  &-a {
    text-align: center;
    opacity: 0;
    transition: opacity 1.5s ease;
    &.is-visible {
      opacity: 1;
    }
    .type-2 & {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    &-answer {
      display: block;
      background: rgba(255, 255, 255, .8);
      box-shadow: rgba(0, 0, 0, .16) 3px 3px 6px;
      border: 1px solid #fff;
      border-radius: 3/375 * 100vw;
      margin-top: 15/310 * 100%;
      margin-left: auto;
      margin-right: auto;
      padding: 6/310 * 100% 0;
      color: #AAAAAA;
      font-size: 13/375 * 100vw;
      font-weight: 400;
      line-height: (28/13);
      letter-spacing: .3em;
      transition: .15s ease;
      @include media() {
        margin-top: 20px;
        border-radius: 5px;
        padding: 9px 0;
        font-size: 14px;
        cursor: pointer;
        transition: .45s ease;
        &:hover {
          border-color: #DF0068;
          color: #DF0068;
          background: rgba(255, 255, 255, 1);
        }
      }
      &.no-visible {
        visibility: hidden;
      }
      .type-1 &,
      .type-3 &,
      .type-4 & {
        width: 275/295 * 100%;
        @include media(){
          width: 300px;
        }
      }
      .type-2 & {
        padding: 3/310 * 100% 0;
        width: 140/310 * 100%;
        letter-spacing: .1em;
        @include media() {
          width: 200px;
          padding: 9px 0;
        }
      }
      &.is-selected {
        border-color: #DF0068;
        color: #DF0068;
        background: rgba(255, 255, 255, 1);
      }
    }
  }
  &-decide {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 25/310 * 100% auto 0;
    width: 160/310 * 100%;
    border: 1px solid #DF0168;
    border-radius: 23/375 * 100vw;
    padding: 16/310 * 100% 0;
    opacity: 0;
    transition: opacity .9s ease;
    &.is-visible {
      opacity: 1;
    }
    @include media() {
      width: 200px;
      margin: 40px auto 0;
      padding: 17px 0;
      border-radius: 45px;
      backface-visibility: hidden;
      &:hover{
        cursor: pointer;
        .question-decide-chara {
          margin: 0 6px;
        }
      }
    }
    &-chara {
      margin: 0 3/375 * 100vw;
      @include media() {
        margin: 0 3px;
        backface-visibility: hidden;
        transition: .6s ease;
      }
      &--n {
        width: 7.77/375 * 100vw;
        height: 8.63/375 * 100vw;
        @include media() {
          width: 9px;
          height: 10px;
          margin-right: 4px;
        }
      }
      &--e {
        width: 5.1/375 * 100vw;
        height: 8.63/375 * 100vw;
        @include media() {
          width: 6px;
          height: 10px;
        }
      }
      &--x {
        width: 7.77/375 * 100vw;
        height: 8.63/375 * 100vw;
        @include media() {
          width: 8px;
          height: 10px;
          margin-right: 5px;
        }
      }
      &--t {
        width: 6.91/375 * 100vw;
        height: 8.63/375 * 100vw;
        @include media() {
          width: 7px;
          height: 10px;
        }
      }
    }
  }
}
</style>
